import React, { useEffect, useState, useRef } from "react";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";

function NavBar() {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const timeoutRef = useRef(null);

  // Reset the inactivity timeout
  const resetTimeout = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      handleLogout();
    }, 120000); // 60,000 ms = 1 minute
  };

  // Detect user interactions
  const setupInactivityListeners = () => {
    const events = ["mousemove", "keydown", "mousedown", "touchstart"];
    events.forEach((event) => {
      window.addEventListener(event, resetTimeout);
    });
    resetTimeout(); // Start the timeout
  };

  const cleanupInactivityListeners = () => {
    const events = ["mousemove", "keydown", "mousedown", "touchstart"];
    events.forEach((event) => {
      window.removeEventListener(event, resetTimeout);
    });
    clearTimeout(timeoutRef.current);
  };

  const handleLogout = () => {
    const auth = getAuth();
    signOut(auth).then(() => {
      cleanupInactivityListeners();
      navigate("/login");
    });
  };

  const authcheck = () => {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (user) {
        if (user.uid === "acbxMiOFkBOFy6IOOMZ8V70L4923") {
          setLoading(false);
          setupInactivityListeners();
        } else {
          navigate("/login");
        }
      } else {
        navigate("/login");
      }
    });
  };

  useEffect(() => {
    authcheck();
    return () => {
      cleanupInactivityListeners(); // Clean up on component unmount
    };
  }, []);
  return (
    <aside className="main-sidebar bg-dark text-light vh-100">
      {/* Brand Logo */}
      <a
        href="https://chainblockinvestment.com"
        className="d-flex align-items-center py-3 px-4 bg-primary text-light text-decoration-none"
      >
        <img
          src="https://img.icons8.com/?size=48&id=23280&format=png"
          className="rounded-circle"
          style={{ opacity: ".8" }}
          width={30}
          alt="Brand Logo"
        />
        <span className="ms-2 fs-5">Investment Admin</span>
      </a>

      {/* Sidebar */}
      <div className="px-3 py-4">
        {/* Sidebar User */}
        <div className="d-flex align-items-center mb-4">
          <div className="me-3">
            <img
              src="https://img.icons8.com/?size=48&id=23280&format=png"
              className="rounded-circle"
              alt="User"
              width={40}
            />
          </div>
          <div>
            <h6 className="mb-0">Darkest Mind</h6>
          </div>
        </div>

        {/* Sidebar Menu */}
        <nav>
          <ul className="nav flex-column">
            <li className="nav-item mb-2">
              <a
                href="/"
                className="nav-link text-light d-flex align-items-center"
              >
                <i className="fas fa-tachometer-alt me-2"></i>
                <span>Dashboard</span>
              </a>
            </li>
            <li className="nav-item mb-2">
              <a
                href="/users"
                className="nav-link text-light d-flex align-items-center"
              >
                <i className="fas fa-users me-2"></i>
                <span>Manage Users</span>
              </a>
            </li>
            <li className="nav-item mb-2">
              <a
                href="/deposits"
                className="nav-link text-light d-flex align-items-center"
              >
                <i className="fas fa-donate me-2"></i>
                <span>Manage Deposits</span>
              </a>
            </li>
            <li className="nav-item mb-2">
              <a
                href="/investments"
                className="nav-link text-light d-flex align-items-center"
              >
                <i className="fas fa-chart-bar me-2"></i>
                <span>Manage Investments</span>
              </a>
            </li>
            {/* <li className="nav-item mb-2">
              <a
                href="/cmdinvestments"
                className="nav-link text-light d-flex align-items-center"
              >
                <i className="fas fa-chart-bar me-2"></i>
                <span>Compounding Investments</span>
              </a>
            </li> */}
            <li className="nav-item mb-2">
              <a
                href="/withdrawals"
                className="nav-link text-light d-flex align-items-center"
              >
                <i className="fas fa-hand-holding-usd me-2"></i>
                <span>Manage Withdrawals</span>
              </a>
            </li>
            <li className="nav-item mb-2">
              <a
                href="/Settings"
                className="nav-link text-light d-flex align-items-center"
              >
                <i className="fas fa-hand-holding-usd me-2"></i>
                <span>Investment Plans</span>
              </a>
            </li>

            <li className="nav-item mb-2">
              <a
                href="/sendmail"
                className="nav-link text-light d-flex align-items-center"
              >
                <i className="fas fa-envelope me-2"></i>
                <span>Webmail</span>
              </a>
            </li>
             <li className="nav-item mb-2">
              <a
                href="/walletsettings"
                className="nav-link text-light d-flex align-items-center"
              >
                <i className="fas fa-envelope me-2"></i>
                <span>Wallet address</span>
              </a>
            </li>

                         <li className="nav-item mb-2">
              <a
                href="/referrals"
                className="nav-link text-light d-flex align-items-center"
              >
                <i className="fas fa-envelope me-2"></i>
                <span>Refferals</span>
              </a>
            </li>


            {/* <li className="nav-item mb-2">
              <a
                href="https://privateemail.com/"
                className="nav-link text-light d-flex align-items-center"
              >
                <i className="fas fa-envelope me-2"></i>
                <span>Webmail</span>
              </a>
            </li> */}
            <li className="nav-item mb-2">
              <a
                href="/logout"
                className="nav-link text-danger d-flex align-items-center"
              >
                <i className="fas fa-power-off me-2"></i>
                <span>Logout</span>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </aside>
  );
}

export default NavBar;

// import React from "react";

// function NavBar() {
//   return (
//     <aside className="main-sidebar sidebar-dark-primary elevation-4">
//       {/* Brand Logo */}
//       <a href="https://chainblockinvestment.com" className="brand-link">
//         <img
//           src="https://img.icons8.com/?size=48&id=23280&format=png"
//           className="brand-image img-circle elevation-2"
//           style={{ opacity: ".8" }}
//           width={30}
//         />
//         <span className="brand-text font-weight-light">Investment Admin</span>
//       </a>
//       {/* Sidebar */}
//       <div className="sidebar">
//         {/* Sidebar user (optional) */}
//         <div className="user-panel mt-3 pb-3 mb-3 d-flex">
//           <div className="image">
//             <img
//               src="https://img.icons8.com/?size=48&id=23280&format=png"
//               className="img-circle elevation-2"
//               alt="User Image"
//             />
//           </div>
//           <div className="info">
//             <a href="#" className="d-block">
//               Darkest Mind
//             </a>
//           </div>
//         </div>
//         {/* Sidebar Menu */}
//         <nav className="mt-2">
//           <ul
//             className="nav nav-pills nav-sidebar flex-column"
//             data-widget="treeview"
//             role="menu"
//             data-accordion="false"
//           >
//             {/* Add icons to the links using the .nav-icon class
// with font-awesome or any other icon font library */}
//             <li className="nav-item">
//               <a href="/" className="nav-link">
//                 <i className="nav-icon fas fa-tachometer-alt" />
//                 <p>Dashboard</p>
//               </a>
//             </li>
//             {/* <li className="nav-item">
//                     <a href="/Settings" className="nav-link">
//                         <i className="nav-icon fas fa-tachometer-alt" />
//                         <p>
//                             Coin Deposit
//                         </p>
//                     </a>
//                 </li> */}

//             <li className="nav-item">
//               <a href="/users" className="nav-link">
//                 <i className="nav-icon fas fa-users" />
//                 <p>Manage Users</p>
//               </a>
//             </li>
//             <li className="nav-item">
//               <a href="/deposits" className="nav-link">
//                 <i className="nav-icon fas fa-donate" />
//                 <p>Manage Deposits</p>
//               </a>
//             </li>
//             <li className="nav-item">
//               <a href="/withdrawals" className="nav-link">
//                 <i className="nav-icon fas fa-hand-holding-usd" />
//                 <p>Manage Withdrawals</p>
//               </a>
//             </li>
//             <li className="nav-item">
//               <a href="/signals" className="nav-link">
//                 <i className="nav-icon fas fa-hand-holding-usd" />
//                 <p>Manage Signals</p>
//               </a>
//             </li>
//             <li className="nav-item">
//               <a href="/trading" className="nav-link">
//                 <i className="nav-icon fas fa-hand-holding-usd" />
//                 <p>Manage Trading</p>
//               </a>
//             </li>

//             <li className="nav-item">
//               <a href="https://privateemail.com/" className="nav-link">
//                 <i className="nav-icon fas fa-envelope" />
//                 <p>Webmail</p>
//               </a>
//             </li>
//             <li className="nav-item">
//               <a href="/logout" className="nav-link">
//                 <i className="nav-icon fas fa-power-off" />
//                 <p>Logout</p>
//               </a>
//             </li>
//           </ul>
//         </nav>
//         {/* /.sidebar-menu */}
//       </div>
//       {/* /.sidebar */}
//     </aside>
//   );
// }

// export default NavBar;
